import { useState, useCallback, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const GalleryCarousel = ({ images, name }) => {
  const [index, setIndex] = useState(0);
  const total = images.length;

  const next = useCallback(() => {
    setIndex((i) => (i + 1) % total);
  }, [total]);

  const prev = useCallback(() => {
    setIndex((i) => (i - 1 + total) % total);
  }, [total]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [next, prev]);

  return (
    <div data-testid="gallery-carousel" className="w-full">
      <div className="relative aspect-[16/10] md:aspect-[16/9] w-full overflow-hidden bg-[#F2EFE9]">
        {images.map((src, i) => (
          <img
            key={src}
            src={src}
            alt={`${name} - foto ${i + 1}`}
            loading={i === 0 ? "eager" : "lazy"}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
              i === index ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}

        <button
          type="button"
          onClick={prev}
          aria-label="Foto anterior"
          data-testid="gallery-prev-button"
          className="absolute top-1/2 left-4 -translate-y-1/2 w-12 h-12 lg:w-14 lg:h-14 bg-white/85 backdrop-blur-sm hover:bg-white text-[#1A2421] flex items-center justify-center shadow-lg transition-colors z-10"
        >
          <ChevronLeft size={22} strokeWidth={1.8} />
        </button>
        <button
          type="button"
          onClick={next}
          aria-label="Próxima foto"
          data-testid="gallery-next-button"
          className="absolute top-1/2 right-4 -translate-y-1/2 w-12 h-12 lg:w-14 lg:h-14 bg-white/85 backdrop-blur-sm hover:bg-white text-[#1A2421] flex items-center justify-center shadow-lg transition-colors z-10"
        >
          <ChevronRight size={22} strokeWidth={1.8} />
        </button>

        <div
          data-testid="gallery-counter"
          className="absolute bottom-4 right-4 px-3 py-1.5 bg-[#1A2421]/80 backdrop-blur-sm text-[#F9F6F0] text-xs font-bold tracking-wider"
        >
          {String(index + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-5 md:grid-cols-8 gap-2">
        {images.map((src, i) => (
          <button
            key={src}
            type="button"
            onClick={() => setIndex(i)}
            aria-label={`Ir para foto ${i + 1}`}
            data-testid={`gallery-thumb-${i}`}
            className={`aspect-square overflow-hidden border-2 transition-all ${
              i === index
                ? "border-[#2C5545] opacity-100"
                : "border-transparent opacity-60 hover:opacity-100"
            }`}
          >
            <img src={src} alt="" className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default GalleryCarousel;
